import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import { useNavigate } from "react-router";
import NotazzCard from "../../../components/apps/notazz/NotazzCard";

export default function Notazz() {
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Notazz"
                description="Notazz"
            />
            <PageBreadcrumb
                pageTitle="Notazz"
                showBackButton={true}
                onBack={handleGoBack}
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">

                <div className="col-span-12 space-y-6">
                    <NotazzCard />
                </div>
            </div>
        </>
    );
}